export default __webpack_public_path__ + "media/images/images/flags/az-f68e001b25d5f8ab9736e74f10b3ead0.png";